import * as path from 'path';

export const assetsFolder = path.join(__dirname, '..', '..', 'assets');
export const defaultStylesCss = path.join(assetsFolder, 'captions.css');
export const indexHtml = path.join(assetsFolder, 'index.html');

export const indexJs = path.join(__dirname, '..', 'player', 'index.js');

export const nodeModules = path.join(__dirname, '..', '..', 'node_modules');
